import { createSelector } from 'reselect'

import { getTimeEntriesByTaskId } from '../utils/time-tracking';

const getUserTimeEntries = (timeEntries, userId, projectIds = [], start = 0, end = Number.POSITIVE_INFINITY) => timeEntries
    .filter(timeEntry =>
        timeEntry.user === userId &&
        projectIds.includes(timeEntry.project) &&
        new Date(timeEntry.start).getTime() >= start &&
        new Date(timeEntry.start).getTime() <= end
    )
    .sort((t1, t2) => new Date(t1.start) < new Date(t2.start) ? 1 : -1);
export const makeGetUserTimeEntries = () => createSelector(getUserTimeEntries, timeEntries => timeEntries);

const getUserCompletedTimeEntries = (timeEntries, userId) => timeEntries
    .filter(timeEntry => timeEntry.user === userId && timeEntry.end)
    .sort((t1, t2) => new Date(t1.start) < new Date(t2.start) ? 1 : -1);
export const makeGetUserCompletedTimeEntries = () => createSelector(getUserCompletedTimeEntries, timeEntries => timeEntries);

const getTimeEntry = (timeEntries, id) => timeEntries.find(timeEntry => timeEntry.id === id);
export const makeGetTimeEntry = () => createSelector(getTimeEntry, timeEntry => timeEntry);

export const makeGetTimeEntriesByTaskId = () => createSelector(getTimeEntriesByTaskId, timeEntries => timeEntries);

const getTimeEntriesByProjectId = (timeEntries, projectId, start = 0, end = Number.POSITIVE_INFINITY) => timeEntries
    .filter(timeEntry =>
        timeEntry.project === projectId &&
        new Date(timeEntry.start).getTime() >= start &&
        new Date(timeEntry.start).getTime() <= end
    )
    .sort((t1, t2) => new Date(t2.start) - new Date(t1.start));
export const makeGetTimeEntriesByProjectId = () => createSelector(getTimeEntriesByProjectId, timeEntries => timeEntries);

const getUserTimeEntriesByTaskId = (timeEntries, userId, taskId) => getTimeEntriesByTaskId(timeEntries, taskId)
    .filter(timeEntry => timeEntry.user === userId);
export const makeGetUserTimeEntriesByTaskId = () => createSelector(getUserTimeEntriesByTaskId, timeEntries => timeEntries);

const getUserRunningTimeEntry = (timeEntries, userId) => timeEntries.find(timeEntry => !timeEntry.end && timeEntry.user === userId);
export const makeGetUserRunningTimeEntry = () => createSelector(getUserRunningTimeEntry, timeEntry => timeEntry);

const getUserRunningTimeEntryByTaskId = (timeEntries, userId, taskId) => timeEntries.find(timeEntry => !timeEntry.end && timeEntry.user === userId && timeEntry.task === taskId);
export const makeGetUserRunningTimeEntryByTaskId = () => createSelector(getUserRunningTimeEntryByTaskId, timeEntry => timeEntry);
